/* eslint-disable no-unused-vars */
import questionnairePopup from './questionnairePopup';
import enlargeImage from './enlargeImage';


jQuery(document).ready(function ($) {
  questionnairePopup();
  enlargeImage();
  // ... any other imports and calls
});
